import { render, staticRenderFns } from "./CorrectStat.vue?vue&type=template&id=1a98ec3e&scoped=true&"
import script from "./CorrectStat.vue?vue&type=script&lang=js&"
export * from "./CorrectStat.vue?vue&type=script&lang=js&"
import style0 from "./CorrectStat.vue?vue&type=style&index=0&id=1a98ec3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98ec3e",
  null
  
)

export default component.exports